/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './sendMessage.defs.js'
export { main as default } from './sendMessage.defs.js'
